/** 通知项目详情刷新基础信息（名称等） */

export type ProjectInfoChangedDetail = {
  projectId: number;
  name?: string;
};

export function notifyProjectInfoChanged(detail: ProjectInfoChangedDetail) {
  if (typeof window === 'undefined' || !detail?.projectId) return;
  window.dispatchEvent(
    new CustomEvent('aipd:project-info-changed', { detail }),
  );
}

export function subscribeProjectInfoChanged(
  fn: (detail: ProjectInfoChangedDetail) => void,
): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<ProjectInfoChangedDetail>).detail;
    const pid = Number(detail?.projectId || 0);
    if (pid > 0) fn({ ...detail, projectId: pid });
  };
  window.addEventListener('aipd:project-info-changed', handler);
  return () => window.removeEventListener('aipd:project-info-changed', handler);
}
